import { render, staticRenderFns } from "./PqrCreate.vue?vue&type=template&id=3f990e58"
import script from "./PqrCreate.vue?vue&type=script&lang=js"
export * from "./PqrCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports